import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight, Lock, Boxes } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../App";
import { Btn, Logo } from "./ui";

export default function PlatformLogin() {
  const { platformLogin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const data = await api.platformLogin({ email, password });
      platformLogin(data);
      navigate("/platform");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="lg-backdrop min-h-screen">
      <div className="lg-grain absolute inset-0 opacity-40" />
      <div className="relative mx-auto flex min-h-screen max-w-md flex-col justify-center px-6 py-10">
        <div className="lg-rise w-full rounded-2xl border border-subtle bg-surface/90 p-8 shadow-2xl backdrop-blur-xl">
          <div className="mb-1 flex items-center">
            <Logo className="h-10" />
          </div>
          <div className="mt-4 flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-slate-500">
            <Boxes className="h-3.5 w-3.5" /> Internal · Platform Operations
          </div>
          <h2 className="mt-2 font-display text-xl font-bold">Staff sign-in</h2>
          <p className="mt-1 text-sm text-slate-400">Cross-tenant platform oversight for LucidGate operators only.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="mb-1.5 block font-mono text-[11px] uppercase tracking-widest text-slate-500">Staff email</label>
              <input
                data-testid="platform-login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-lg border border-subtle bg-elevated px-3 py-2.5 text-sm outline-none focus:border-brand"
                placeholder="you@lucidgate.internal"
                required
              />
            </div>
            <div>
              <label className="mb-1.5 block font-mono text-[11px] uppercase tracking-widest text-slate-500">Password</label>
              <div className="relative">
                <Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
                <input
                  data-testid="platform-login-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full rounded-lg border border-subtle bg-elevated py-2.5 pl-9 pr-3 text-sm outline-none focus:border-brand"
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>

            {err && (
              <div data-testid="platform-login-error" className="rounded-lg border border-block/40 bg-block/10 px-3 py-2 text-sm text-block">{err}</div>
            )}

            <Btn data-testid="platform-login-submit" type="submit" disabled={busy} className="w-full">
              {busy ? "Authenticating…" : "Enter Platform Console"} <ArrowRight className="h-4 w-4" />
            </Btn>
          </form>

          <button
            type="button"
            data-testid="platform-fill-demo"
            onClick={() => { setEmail("ops@lucidgate.internal"); setPassword("lucidgate-ops"); }}
            className="mt-4 w-full rounded-lg border border-dashed border-subtle py-2 font-mono text-[11px] uppercase tracking-widest text-slate-500 transition-colors hover:border-brand/50 hover:text-brand"
          >
            Fill staff demo credentials
          </button>
          <Link to="/login" data-testid="platform-back-tenant" className="mt-3 block text-center font-mono text-[11px] text-slate-600 underline hover:text-slate-400">
            ← Back to tenant sign-in
          </Link>
        </div>
      </div>
    </div>
  );
}
